import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Building2 } from "lucide-react";

export const STAFF_ROLES = ["admin", "sales_team", "property_uploader", "accounts"];

function BrandLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5]">
      <div className="flex flex-col items-center gap-4" data-testid="brand-loader">
        <div className="h-14 w-14 rounded-lg bg-[#0B192C] flex items-center justify-center animate-pulse">
          <Building2 className="h-7 w-7 text-[#C5A059]" />
        </div>
        <div className="overline text-slate-500">Loading OwnNest…</div>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) return <BrandLoader />;
  if (user === false) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  // "staff" is a shortcut for any admin-panel-capable role
  const allowed = Array.isArray(role)
    ? role
    : role === "staff"
      ? STAFF_ROLES
      : role === "admin"
        ? ["admin"]
        : role === "investor"
          ? ["investor"]
          : role
            ? [role]
            : null;
  if (allowed && !allowed.includes(user.role)) {
    // Redirect users to their natural home page
    if (STAFF_ROLES.includes(user.role)) return <Navigate to="/admin" replace />;
    return <Navigate to="/portfolio" replace />;
  }
  return children;
}
